/* OBFUSCATED CODE - INTELLECTUAL PROPERTY PROTECTED */
export const presets = {
  'Fat Cap': {
    name: 'Fat Cap',
    scaleVal: 0.8,
    densityVal: 3500,
    speedFactor: 2.5,
    description: 'Fat Cap 20-40cm: жирный наплыв до 40 сантиметров',
    paintConsumption: 1,
    enableDrips: true,
    dripChance: 1,
    dripDelay: 0.5,
    minRadius: 40,
    maxRadius: 50,
    minDensity: 5000,
    maxDensity: 5500,
    rollerWidth: 150,
    rollerHeight: 30
  },
  'Universal Cap': {
    name: 'Universal Cap',
    description: 'Средний кэп: 25 см до стены',
    scaleVal: 0.8,
    radiusVal: 20,
    densityVal: 6700,
    speedFactor: 3.8,
    paintConsumption: 2,
    enableDrips: true,
    dripChance: 1,
    dripDelay: 0.5,
    dripWidthVariation: 1,
    minDensity: 6700,
    maxDensity: 7000,
    minSpeedFactor: 3.5,
    maxSpeedFactor: 4.0,
    rollerWidth: 100,
    rollerHeight: 20
  },
  'Night Quill Slim Dart': {
    name: 'Night Quill Slim Dart',
    description: 'Night Quill Slim Dart 0.3-2cm: ультратонкая насадка для четких линий',
    scaleVal: 1,
    radiusVal: 14,
    densityVal: 6000,
    speedFactor: 5,
    minSpeedFactor: 6.0,
    maxSpeedFactor: 7.0,
    enableDrips: true,
    dripDelay: 1,
    dripLength: 7,
    dripMaxLength: 1,
    dripAlpha: 0.1,
    dripChance: 1,
    dripWidth: 1,
    dripWidthVariation: 1,
    cloudShape: 'elliptical',
    layers: 3,
    centerBias: 0.7,
    edgeFog: true,
    paintConsumption: 4,
    rollerWidth: 60,
    rollerHeight: 15
  },
  Roll: {
    name: 'Roll',
    description: 'Грунт',
    edgeFog: true,
    scaleVal: 0.5,
    radiusVal: 1,
    densityVal: 8000,
    speedFactor: 5.0,
    paintConsumption: 1,
    enableDrips: false,
    rollerWidth: 150,
    rollerHeight: 30
  },
  'Needle Cap': {
    name: 'Needle Cap',
    description: 'кэп с шириной линии 0.2-1см',
    scaleVal: 1.2,
    radiusVal: 4,
    densityVal: 9500,
    speedFactor: 7.0,
    paintConsumption: 0.5,
    enableDrips: false,
    rollerWidth: 20,
    rollerHeight: 5
  },
  cap_81_female: {
    name: 'cap_81_female',
    description: 'Кэп 81 Cap Female 40-81см: плоский вертикальный наплыв',
    scaleVal: 1,
    radiusVal: 8,
    densityVal: 4000,
    speedFactor: 5.5,
    paintConsumption: 4.5,
    enableDrips: true,
    dripChance: 4,
    dripDelay: 0.3,
    dripWidthVariation: 2,
    minDensity: 3000,
    maxDensity: 6000,
    minSpeedFactor: 4.5,
    maxSpeedFactor: 6.5,
    rollerWidth: 200,
    rollerHeight: 40
  },
  hardcore_fat: {
    name: 'hardcore_fat',
    description: 'Кэп MTN Hardcore Fat 3-12.5см: быстрое закрашивание больших площадей',
    scaleVal: 0.9,
    radiusVal: 35,
    densityVal: 4800,
    speedFactor: 4.5,
    paintConsumption: 3.5,
    enableDrips: true,
    dripChance: 2,
    dripDelay: 0.4,
    dripWidthVariation: 2,
    rollerWidth: 130,
    rollerHeight: 25
  },
  skinny_cream: {
    name: 'skinny_cream',
    description: 'MTN 94 Cap: стандартная гибкая насадка 1.1-1.6см',
    scaleVal: 1.0,
    radiusVal: 12,
    densityVal: 6200,
    speedFactor: 5.5,
    paintConsumption: 2.5,
    enableDrips: true,
    dripChance: 1,
    dripDelay: 0.8,
    dripWidthVariation: 1,
    rollerWidth: 70,
    rollerHeight: 18
  },
  ny_fat: {
    name: 'ny_fat',
    description: 'NY Fat 1-6см: Американская насадка, плотная и круглая',
    scaleVal: 1.1,
    radiusVal: 16,
    densityVal: 9000,
    speedFactor: 5.0,
    paintConsumption: 2.0,
    enableDrips: true,
    dripChance: 1,
    dripDelay: 0.5,
    dripWidthVariation: 1,
    edgeFog: true,
    centerBias: 1,
    flat: true
  },
  'BIG Roller': {
    name: 'BIG Roller',
    description: 'Большой валик 40см',
    edgeFog: true,
    scaleVal: 0.5,
    radiusVal: 1,
    densityVal: 8000,
    speedFactor: 5.0,
    paintConsumption: 1,
    enableDrips: false,
    rollerWidth: 150,
    rollerHeight: 30
  },
  'MID Roller': {
    name: 'MID Roller',
    description: 'Средний валик 20см',
    edgeFog: true,
    scaleVal: 0.5,
    radiusVal: 1,
    densityVal: 8000,
    speedFactor: 5.0,
    paintConsumption: 1,
    enableDrips: false,
    rollerWidth: 100,
    rollerHeight: 20
  },
  'SMALL Roller': {
    name: 'SMALL Roller',
    description: 'Маленький валик 5см',
    edgeFog: true,
    scaleVal: 0.5,
    radiusVal: 1,
    densityVal: 8000,
    speedFactor: 5.0,
    paintConsumption: 1,
    enableDrips: false,
    rollerWidth: 60,
    rollerHeight: 15
  }
};
export const calculateDynamicParams = (paintRemaining, presetKey) => {
  const preset = presets[presetKey];
  const MAX_PAINT = 10000;
  const LOW_THRESHOLD = 1000;
  if (!preset) return {
    radius: preset?.radiusVal || 45,
    density: preset?.densityVal || 5600,
    speedFactor: preset?.speedFactor || 1.5
  };
  if (presetKey === 'Fat Cap') {
    if (paintRemaining <= LOW_THRESHOLD) {
      return {
        radius: preset.maxRadius || 65,
        density: preset.minDensity || 2000,
        speedFactor: preset.speedFactor
      };
    }
    const progress = 1 - (Math.max(0, paintRemaining - LOW_THRESHOLD) / (MAX_PAINT - LOW_THRESHOLD));
    const radius = preset.minRadius + (preset.maxRadius - preset.minRadius) * progress;
    const density = preset.maxDensity - (preset.maxDensity - preset.minDensity) * progress;
    return {
      radius: Math.round(radius),
      density: Math.round(density),
      speedFactor: preset.speedFactor
    };
  }
  if (presetKey === 'Universal Cap' || presetKey === 'cap_81_female') {
    if (paintRemaining <= LOW_THRESHOLD) {
      return {
        radius: preset.radiusVal,
        density: preset.minDensity || 1500,
        speedFactor: preset.minSpeedFactor || 1.5
      };
    }
    const progress = 1 - (Math.max(0, paintRemaining - LOW_THRESHOLD) / (MAX_PAINT - LOW_THRESHOLD));
    const density = preset.maxDensity - (preset.maxDensity - preset.minDensity) * progress;
    const speedFactor = preset.maxSpeedFactor - (preset.maxSpeedFactor - preset.minSpeedFactor) * progress;
    return {
      radius: preset.radiusVal,
      density: Math.round(density),
      speedFactor: parseFloat(speedFactor.toFixed(1))
    };
  }
  if (presetKey === 'Night Quill Slim Dart') {
    if (paintRemaining <= LOW_THRESHOLD) {
      return {
        radius: preset.radiusVal,
        density: preset.densityVal,
        speedFactor: preset.minSpeedFactor || 2.0
      };
    }
    const progress = 1 - (Math.max(0, paintRemaining - LOW_THRESHOLD) / (MAX_PAINT - LOW_THRESHOLD));
    const speedFactor = preset.minSpeedFactor + (preset.maxSpeedFactor - preset.minSpeedFactor) * progress;
    return {
      radius: preset.radiusVal,
      density: preset.densityVal,
      speedFactor: parseFloat(speedFactor.toFixed(1))
    };
  }
  return {
    radius: preset?.radiusVal || 45,
    density: preset?.densityVal || 5600,
    speedFactor: preset?.speedFactor || 1.5
  };
};
export const defaultCans = () => {
  const initial = [];
  for (let i = 1; i <= 4; i++) {
    const color = i === 1 ? '#ffffff' : null;
    initial.push({
      id: i,
      type: 'roller',
      color: color,
      paintLeft: 10000,
      isActive: i === 1
    });
  }
  for (let i = 5; i <= 11; i++) {
    let color = null;
    let isActive = false;
    let paintLeft = 10000;
    if (i === 5) color = '#ff3366';
    else if (i === 6) color = '#e1ff00';
    else if (i === 7) color = '#ffffff';
    else if (i === 8) color = '#000000';
    initial.push({
      id: i,
      type: 'spray',
      color,
      paintLeft,
      isActive
    });
  }
  return initial;
};